module.exports = __webpack_public_path__ + "img/ewm_bg.92a909da.png";